var map = {
	"./inter/inter-v20-latin-600.woff2": 51,
	"./inter/inter-v20-latin-600italic.woff2": 52,
	"./inter/inter-v20-latin-700.woff2": 53,
	"./inter/inter-v20-latin-700italic.woff2": 54,
	"./inter/inter-v20-latin-italic.woff2": 55,
	"./inter/inter-v20-latin-regular.woff2": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;